import { useEffect } from "react";
import Lenis from "lenis";
import { ContentProvider, LangProvider } from "@/lib/content";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import IntroSection from "@/components/IntroSection";
import Marquee from "@/components/Marquee";
import ExamSection from "@/components/ExamSection";
import Quiz from "@/components/Quiz";
import Flashcards from "@/components/Flashcards";
import N400Simulator from "@/components/N400Simulator";
import DictationTool from "@/components/DictationTool";
import Bento from "@/components/Bento";
import Interview from "@/components/Interview";
import ExemptionsSection from "@/components/ExemptionsSection";
import Timeline from "@/components/Timeline";
import GuidesSection from "@/components/GuidesSection";
import Pricing from "@/components/Pricing";
import LeadForm from "@/components/LeadForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <ContentProvider>
        <Nav />
        <main>
          <Hero />
          <IntroSection />
          <Marquee />
          <ExamSection />
          <Quiz />
          <Flashcards />
          <N400Simulator />
          <DictationTool />
          <Bento />
          <Interview />
          <ExemptionsSection />
          <Timeline />
          <GuidesSection />
          <Pricing />
          <LeadForm />
          <FAQ />
        </main>
        <Footer />
      </ContentProvider>
    </LangProvider>
  );
}
